export class UserRole
{
    userRoleId: number;
    name: string;
    description: string;
}
